module.exports = __webpack_public_path__ + "assets/img/return-cbb77252.png";